import { render, staticRenderFns } from "./Automatic.vue?vue&type=template&id=a64d3bf0&scoped=true"
import script from "./Automatic.vue?vue&type=script&lang=js"
export * from "./Automatic.vue?vue&type=script&lang=js"
import style0 from "./Automatic.vue?vue&type=style&index=0&id=a64d3bf0&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a64d3bf0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/prod-www.dijie360.com-nginx/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a64d3bf0')) {
      api.createRecord('a64d3bf0', component.options)
    } else {
      api.reload('a64d3bf0', component.options)
    }
    module.hot.accept("./Automatic.vue?vue&type=template&id=a64d3bf0&scoped=true", function () {
      api.rerender('a64d3bf0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/mechanism/components/SettleFlod/Child/Automatic.vue"
export default component.exports